// Tables de correspondance compte / poste (source : "Table de correspondance compte et poste")
// utilisées pour déterminer les valeurs par défaut PCEMF par préfixe de compte.

// Sens du solde (C = CREDIT, D = DEBIT, I = INDIFFERENT)
// Généré depuis l'état FM1000 (colonnes soldes de clôture Débit / Crédit).
export const SENS_SOLDE_MAP: Record<string, string> = {
  '1': 'C', '103': 'D', '122': 'D', '132': 'D',
  '2': 'D', '28': 'C', '29': 'C',
  '3': 'D', '35': 'C', '36': 'C', '37': 'I', '373': 'C', '374': 'C', '375': 'D',
  '376': 'D', '377': 'C', '38': 'C', '386': 'D', '387': 'D', '3881': 'D', '39': 'C',
  '4': 'D', '40': 'C', '409': 'D', '412': 'C', '42': 'C', '421': 'D', '425': 'I',
  '430': 'C', '4304': 'I', '4305': 'D', '431': 'C', '4312': 'D', '432': 'I',
  '433': 'I', '44': 'C', '441': 'D', '4415': 'C', '4416': 'C', '4417': 'C',
  '4419': 'C', '442': 'I', '447': 'D', '448': 'D', '45': 'I', '461': 'I',
  '462': 'I', '4632': 'C', '4634': 'C', '465': 'C', '468': 'I', '472': 'C',
  '475': 'C', '478': 'I',
  '5': 'D', '52': 'C', '521': 'D', '5214': 'C', '5215': 'C', '5216': 'C',
  '525': 'D', '526': 'D', '528': 'D', '532': 'C', '539': 'C', '543': 'C',
  '544': 'C', '549': 'C', '552': 'C', '559': 'C', '56': 'I', '563': 'D',
  '564': 'C', '568': 'D', '569': 'C', '59': 'C',
  '6': 'D', '6402': 'I', '6403': 'C',
  '7': 'C', '7402': 'D',
  '8': 'D', '87': 'I',
  '9': 'D', '91': 'C', '93': 'C', '94': 'C', '941': 'D', '96': 'C',
  '9713': 'C', '9714': 'C', '9723': 'C', '9724': 'C', '974': 'I',
  '981': 'C', '9811': 'D', '9822': 'C', '983': 'C', '990': 'C', '992': 'C',
  '9942': 'C', '995': 'C', '997': 'I', '9984': 'C', '999': 'C', '9991': 'D',
};

// Catégorie de compte (D = DEPOTS, E = ENGAGEMENTS, I = COMPTABILITE, P = EPARGNES, S = PART SOCIALES)
export const CATEGO_CPT_MAP: Record<string, string> = {
  '10': 'S',                                    // Capital, parts sociales et dotations
  '30': 'E', '31': 'E', '32': 'E', '33': 'E',   // Crédits à la clientèle
  '34': 'E', '39': 'E',                         // Autres opérations / provisions clientèle
  '35': 'P',                                    // Dépôts à régime spécial (épargne)
  '36': 'D',                                    // Dépôts à terme
  '37': 'D', '373': 'P',                        // Comptes à vue / comptes sur livrets
  '38': 'D',                                    // Autres comptes de la clientèle
  '9': 'E',                                     // Hors bilan (engagements)
};

// Type de compte (C = COURANT, D = DAT, E = ENGAGEMENTS, I = INTERNES, IN = INDIFFERENT,
// O = COMPTES CLIENTS, P = EPARGNE, SC = COURANT SPECIFIQUE, SP = EPARGNE SPECIFIQUE)
export const TYP_CPT_MAP: Record<string, string> = {
  '30': 'E', '31': 'E', '32': 'E', '33': 'E',   // Crédits à la clientèle (engagements)
  '34': 'E', '39': 'E',
  '35': 'P',                                    // Épargne à régime spécial
  '36': 'D',                                    // Dépôts à terme
  '37': 'O', '371': 'C', '372': 'C',            // Comptes courants / chèques
  '373': 'P',                                   // Comptes sur livrets
  '38': 'O',                                    // Autres comptes de la clientèle
  '9': 'E',                                     // Hors bilan (engagements)
};
